export const BenArr = {
  getLastItem<T>(list: Array<T>): T | null {
    // 检查数组是否为空
    if (list.length === 0) return null
    // 返回最后一个元素
    return list[list.length - 1]
  },
}
